import { Box, Button, IconButton, Typography } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { KeyboardArrowDown, KeyboardArrowRight } from "@mui/icons-material";
import { mkConfig, generateCsv, download } from "export-to-csv";
import { TbFileTypePdf } from "react-icons/tb";
import { Tag } from "antd";
import React, { useState, useEffect } from "react";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";

const CustomTable = ({
  columns,
  data,
  component,
  handleExportRows,
  hours,
  onTableInstance,
  setOffHours,
  FormatTime,
  sidebor,
  key,
  selectedType,
}) => {
  const DetailPanel = React.memo(({ row }) => {
    const { tasks = [], comments = [] } = row.original; // Support tasks (for type 5) and comments (for type 3)
    const [expandedTasks, setExpandedTasks] = useState({});
    const [expandedEmployees, setExpandedEmployees] = useState({});
    const [expandedClients, setExpandedClients] = useState({});

    const toggleTask = (index) => {
      setExpandedTasks((prev) => ({
        ...prev,
        [index]: !prev[index],
      }));
    };

    const toggleEmployee = (employeeName) => {
      setExpandedEmployees((prev) => ({
        ...prev,
        [employeeName]: !prev[employeeName],
      }));
    };

    // For selectedType === 3, group comments by employee with adjusted widths
    if (selectedType === 3) {
      const commentsByEmployee = comments.reduce((acc, comment) => {
        const employee = comment.Employee || "Unknown";
        if (!acc[employee]) {
          acc[employee] = [];
        }
        acc[employee].push(comment);
        return acc;
      }, {});

      return (
        <>
          {Object.entries(commentsByEmployee).map(
            ([employee, employeeComments], empIndex) => (
              <Box key={empIndex} sx={{ borderBottom: "1px solid #ccc" }}>
                {/* Employee Row */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    padding: "8px 16px",
                    backgroundColor: "#f5f5f5",
                    cursor: "pointer",
                    "&:hover": { backgroundColor: "#e0e0e0" },
                  }}
                  onClick={() => toggleEmployee(employee)}
                >
                  <Box sx={{ width: "22.22%" }} /> {/* Projects column space */}
                  <Box sx={{ width: "4%", marginLeft: "-5px" }}>
                    {" "}
                    {/* Expand icon space */}
                    <IconButton size="small" sx={{ fontSize: "16px" }}>
                      {expandedEmployees[employee] ? (
                        <KeyboardArrowDown />
                      ) : (
                        <KeyboardArrowRight />
                      )}
                    </IconButton>
                  </Box>
                  <Box sx={{ width: "22.22%" }}>
                    <Typography
                      style={{
                        fontSize: "12px",
                        textAlign: "left",
                        width: "100%",
                        display: "block",
                      }}
                    >
                      {employee}
                    </Typography>
                  </Box>
                  <Box sx={{ width: "44.44%" }} /> {/* Comments column space */}
                  <Box sx={{ width: "11.11%", textAlign: "right" }}>
                    <Typography style={{ fontSize: "12px" }}>
                      {employeeComments
                        .reduce(
                          (sum, comment) =>
                            sum + parseFloat(comment.Comment_hrs || 0),
                          0
                        )
                        .toFixed(2)}
                    </Typography>
                  </Box>
                </Box>

                {/* Comment Rows */}
                {expandedEmployees[employee] &&
                  employeeComments.map((comment, commentIndex) => (
                    <Box
                      key={commentIndex}
                      sx={{
                        display: "flex",
                        padding: "4px 16px",
                        fontSize: "12px",
                        backgroundColor:
                          commentIndex % 2 === 0 ? "#fafafa" : "#fff",
                      }}
                    >
                      <Box sx={{ width: "22.22%" }} />{" "}
                      {/* Projects column space */}
                      <Box sx={{ width: "4%" }} /> {/* Expand icon space */}
                      <Box sx={{ width: "22.22%" }} />{" "}
                      {/* Employee column space */}
                      <Box sx={{ width: "44.44%" }}>
                        <Typography
                          style={{
                            fontSize: "12px",
                            textAlign: "left",
                            width: "100%",
                            display: "block",
                            wordWrap: "break-word",
                          }}
                        >
                          {comment.content || "No content"}
                        </Typography>
                      </Box>
                      <Box sx={{ width: "11.11%", textAlign: "right" }}>
                        <Typography style={{ fontSize: "12px" }}>
                          {comment.Comment_hrs}
                        </Typography>
                      </Box>
                    </Box>
                  ))}
              </Box>
            )
          )}
        </>
      );
    }
    // if (selectedType === 6) {

    //   return (
    //     <>
    //       {data.map((client, clientIndex) => (
    //         <Box key={clientIndex} sx={{ borderBottom: '1px solid #ccc' }}>
    //           {/* Client Row */}
    //           <Box
    //             sx={{
    //               display: 'flex',
    //               alignItems: 'center',
    //               padding: '8px 16px',
    //               backgroundColor: '#dfe6ed',
    //               cursor: 'pointer',
    //               '&:hover': { backgroundColor: '#cfd8dc' },
    //             }}
    //             onClick={() => toggleClient(clientIndex)}
    //           >
    //             <Box sx={{ width: '4%' }}>
    //               <IconButton size="small" sx={{ fontSize: '16px' }}>
    //                 {expandedClients[clientIndex] ? <KeyboardArrowDown /> : <KeyboardArrowRight />}
    //               </IconButton>
    //             </Box>
    //             <Box sx={{ width: '22.22%' }}>
    //               <Typography sx={{ fontSize: '12px' }}>{client.client_name}</Typography>
    //             </Box>
    //             <Box sx={{ width: '22.22%' }} /> {/* Projects column (empty) */}
    //             <Box sx={{ width: '22.22%' }}>
    //               <Typography sx={{ fontSize: '12px' }}>{client.totalHours}</Typography>
    //             </Box>
    //             <Box sx={{ width: '11.11%' }} />
    //             <Box sx={{ width: '11.11%' }} />
    //             <Box sx={{ width: '7.11%' }} />
    //           </Box>

    //           {/* Project Rows - Shown Only If Expanded */}
    //           {expandedClients[clientIndex] &&
    //             client.projects.map((project, projectIndex) => (
    //               <Box
    //                 key={projectIndex}
    //                 sx={{
    //                   display: 'flex',
    //                   padding: '4px 16px',
    //                   fontSize: '12px',
    //                   backgroundColor: projectIndex % 2 === 0 ? '#fafafa' : '#fff',
    //                 }}
    //               >
    //                 <Box sx={{ width: '4%' }} /> {/* Indent for expand icon */}
    //                 <Box sx={{ width: '22.22%' }} /> {/* Client name column (empty) */}
    //                 <Box sx={{ width: '22.22%' }}>{project.project_name}</Box> {/* Projects column */}
    //                 <Box sx={{ width: '22.22%' }}>{project.projectHours}</Box> {/* Current week */}
    //                 <Box sx={{ width: '11.11%' }} />
    //                 <Box sx={{ width: '11.11%' }} />
    //                 <Box sx={{ width: '7.11%' }} />
    //               </Box>
    //             ))}

    //         </Box>
    //       ))}

    //     </>
    //   );
    // }
    //For selectedType === 5, render tasks with nested comments (unchanged)
    return (
      <>
        {tasks.map((task, taskIndex) => (
          <Box key={taskIndex} sx={{ borderBottom: "1px solid #ccc" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                padding: "8px 16px",
                backgroundColor: "#f5f5f5",
                cursor: "pointer",
                "&:hover": { backgroundColor: "#e0e0e0" },
              }}
              onClick={() => toggleTask(taskIndex)}
            >
              <Box sx={{ width: "25%" }} /> {/* Projects column space */}
              <Box sx={{ width: "4%", marginLeft: "-5px" }}>
                <IconButton size="small" sx={{ fontSize: "16px" }}>
                  {expandedTasks[taskIndex] ? (
                    <KeyboardArrowDown />
                  ) : (
                    <KeyboardArrowRight />
                  )}
                </IconButton>
              </Box>
              <Box sx={{ width: "20%" }}>
                <Typography style={{ fontSize: "12px" }}>
                  {task.task}
                </Typography>
              </Box>
              <Box sx={{ width: "20%" }} /> {/* Employee column space */}
              <Box sx={{ width: "20%" }} /> {/* Comments column space */}
              <Box sx={{ width: "10%", textAlign: "right" }}>
                <Typography style={{ fontSize: "12px" }}>
                  {task.TaskHours}
                </Typography>
              </Box>
            </Box>

            {/* Comment Rows */}
            {expandedTasks[taskIndex] &&
              task.comments.map((comment, commentIndex) => (
                <Box
                  key={commentIndex}
                  sx={{
                    display: "flex",
                    padding: "4px 16px",
                    fontSize: "12px",
                    backgroundColor:
                      commentIndex % 2 === 0 ? "#fafafa" : "#fff",
                  }}
                >
                  <Box sx={{ width: "25%" }} /> {/* Projects column space */}
                  <Box sx={{ width: "4%" }} /> {/* Expand icon space */}
                  <Box sx={{ width: "20%" }} /> {/* Task name space */}
                  <Box sx={{ width: "20%" }}>
                    <Typography style={{ fontSize: "12px" }}>
                      {comment.Employee || "Unknown"}
                    </Typography>
                  </Box>
                  <Box sx={{ width: "20%" }}>
                    <Typography style={{ fontSize: "12px" }}>
                      {comment.content || "No content"}
                    </Typography>
                  </Box>
                  <Box sx={{ width: "10%", textAlign: "right" }}>
                    <Typography style={{ fontSize: "12px" }}>
                      {comment.Comment_hrs}
                    </Typography>
                  </Box>
                </Box>
              ))}
          </Box>
        ))}
      </>
    );
  });

  const [Hours, setHours] = useState(hours);
  const table = useMaterialReactTable({
    data: data,
    columns: columns,
    enableExpandAll: false,
    enableExpanding:
      selectedType === 3 ||
      selectedType === 4 ||
      selectedType === 5 ||
      selectedType === 6,
    ...(selectedType === 3 || selectedType === 5
      ? {
          columns,
          data: data.length > 0 && data,
          enableExpanding: true,
          getRowCanExpand: (row) =>
            selectedType === 3
              ? !!row.original.comments?.length
              : !!row.original.tasks?.length,
          renderDetailPanel: ({ row }) => <DetailPanel row={row} />,
          muiTableBodyRowProps: ({ row }) => ({
            sx: {
              cursor: row.getCanExpand() ? "pointer" : "default",
            },
          }),
        }
      : {}),

    displayColumnDefOptions: {
      "mrt-row-expand": {
        size: 30,
        minSize: 30,
        maxSize: 40,
      },
    },
    enableGlobalFilter:
      component !== "Report" &&
      component !== "Project Report" &&
      component !== "Project Create" &&
      component !== "Allocation" &&
      component !== "InvoiceReport",
    enableFullScreenToggle: false,
    enableColumnFilters: false,
    enableDensityToggle: false, 
    enableColumnVisibility: false,
    enableHiding: false,
    defaultDisplayColumn: {
      enableColumnOrdering: true,
      enableColumnResizing: true,
      minSize: 100,
    },
    initialState: {
      pagination: { pageSize: 100, pageIndex: 0 },
      sorting: [
        {
          id: "comments_Date",
          desc: true,
        },
      ],
    },
    renderTopToolbarCustomActions:
      component === "Report" ||
      component === "Allocation" ||
      component === "Project Report" 
      // ||
      // component === "Project Create"
        ? ({ table }) => (
            <Box
              sx={{
            display: "flex",
            gap: "16px",
            padding: "8px",
            flexWrap: "wrap",
            justifyContent: "end",
            width: "100%",
            height: "70px",
            alignItems: "center"
              }}
            >
              <label className='text-[13px] font-[600] text-[#555]' style={{ marginRight: '10px' }}>Total Hours : {Hours}</label>
            </Box>
          )
        : component === "InvoiceReport"
        ? ({ table }) => (
            <Box
              sx={{
                display: "flex",
                gap: "16px",
                padding: "8px",
                flexWrap: "wrap",
                justifyContent: "end",
                width: "100%",
              }}
            >
              <Button
                onClick={() =>
                  handleExportRows(table.getPrePaginationRowModel().rows)
                }
                startIcon={<TbFileTypePdf />}
              >
                generate
              </Button>
            </Box>
          )
        : null,
  });

  useEffect(() => {
    if (onTableInstance) {
      onTableInstance(table);
    }
  }, [table]);

  useEffect(() => {
    if (
      table &&
      (component === "Report" ||
        component === "Allocation" ||
        component === "Project Report" ||
        component === "Project Create")
    ) {
      const visibleRows = table.getRowModel().rows;
      const filteredRows =
        selectedType === 4
          ? visibleRows.filter((row) => row.depth === 0)
          : visibleRows;
      const totalHours = filteredRows.reduce((sum, row) => {
        const taskName = row.getValue("task_name") || "";
        if (taskName.toLowerCase() === "leave") return sum;
        const value = row.getValue("Hours");
        if (typeof value === "number") {
          return sum + value;
        }
        const floatVal = parseFloat(value);
        return isNaN(floatVal) ? sum : sum + floatVal;
      }, 0);
      const offHours = filteredRows.reduce((sum, row) => {
        const taskName = row.getValue("task_name") || "";
        if (taskName.toLowerCase() !== "leave") return sum;
        const value = row.getValue("Hours");
        if (typeof value === "number") {
          return sum + value;
        }
        const floatVal = parseFloat(value);
        return isNaN(floatVal) ? sum : sum + floatVal;
      }, 0);
      // const formatted = parseFloat(totalHours.toFixed(2));
      const formattedOff = parseFloat(offHours.toFixed(2));
      // setHours(formatted);
      if (setOffHours) setOffHours(formattedOff);

      let temp = 0;
      data.forEach((item) => {
        temp += parseFloat(item.Hours) || 0;
      });
            const formatted = parseFloat(temp.toFixed(2));
            setHours(formatted);
    }
  }, [table?.getRowModel().rows]);

  return (
    <div className={sidebor ? "material_Expand" : "material_Expandless"}>
      <MaterialReactTable
        table={table}
        key={key}
        muiTablePaginationProps={{
          rowsPerPageOptions: [5, 10, 20],
        }}
        muiTableBodyRowProps={(row) => ({
          sx: {
            fontWeight: row.getValue("project") === "Total" ? 700 : "normal",
          },
        })}
        getSubRows={(row) => row.subRows || []}
      />
    </div>
  );
};

export default CustomTable;
